import React, { Component } from 'react';

const BettingInfo = (props) => {

    const { label, value } = props
        return (
            <tr>
                <td className="sports_cart_style1">{label}<span className="sports_cart_style2">{value}</span></td>
            </tr>
        );
}

export default BettingInfo;


// WEBPACK FOOTER //
// ./src/components/sports/sportscomponent/BettingInfo.js